

import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewEncapsulation
} from '@angular/core';

import { zoomBadgeMotion } from 'mwc/core/animation';
import { MwcSafeAny, MwcSizeDSType } from 'mwc/core/types';

@Component({
  selector: 'mwc-badge-sup',
  exportAs: 'mwcBadgeSup',
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [zoomBadgeMotion],
  template: `
    <ng-container *ngIf="count <= mwcOverflowCount; else overflowTemplate">
      <span
        [mwcNoAnimation]="noAnimation"
        *ngFor="let n of maxNumberArray; let i = index"
        class="mwc-scroll-number-only"
        [style.transform]="'translateY(' + -countArray[i] * 100 + '%)'"
      >
        <ng-container *ngIf="!mwcDot && countArray[i] !== undefined">
          <p
            *ngFor="let p of countSingleArray"
            class="mwc-scroll-number-only-unit"
            [class.current]="p === countArray[i]"
          >
            {{ p }}
          </p>
        </ng-container>
      </span>
    </ng-container>
    <ng-template #overflowTemplate>{{ mwcOverflowCount }}+</ng-template>
  `,
  host: {
    class: 'mwc-scroll-number',
    '[@.disabled]': `disableAnimation`,
    '[@zoomBadgeMotion]': '',
    '[attr.title]': `mwcTitle === null ? '' : mwcTitle || mwcCount`,
    '[style]': `mwcStyle`,
    '[style.right.px]': `mwcOffset && mwcOffset[0] ? -mwcOffset[0] : null`,
    '[style.margin-top.px]': `mwcOffset && mwcOffset[1] ? mwcOffset[1] : null`,
    '[class.mwc-badge-count]': `!mwcDot`,
    '[class.mwc-badge-count-sm]': `mwcSize === 'small'`,
    '[class.mwc-badge-dot]': `mwcDot`,
    '[class.mwc-badge-multiple-words]': `countArray.length >= 2`
  }
})
export class MwcBadgeSupComponent implements OnInit, OnChanges {
  @Input() mwcOffset?: [number, number];
  @Input() mwcTitle?: string | null | undefined;
  @Input() mwcStyle: { [key: string]: string } | null = null;
  @Input() mwcDot = false;
  @Input() mwcOverflowCount: number = 99;
  @Input() disableAnimation = false;
  @Input() mwcCount?: number | TemplateRef<MwcSafeAny>;
  @Input() noAnimation = false;
  @Input() mwcSize: MwcSizeDSType = 'default';
  maxNumberArray: string[] = [];
  countArray: number[] = [];
  count: number = 0;
  countSingleArray = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

  constructor() {}

  generateMaxNumberArray(): void {
    this.maxNumberArray = this.mwcOverflowCount.toString().split('');
  }

  ngOnInit(): void {
    this.generateMaxNumberArray();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { mwcOverflowCount, mwcCount } = changes;
    if (mwcCount && typeof mwcCount.currentValue === 'number') {
      this.count = Math.max(0, mwcCount.currentValue);
      this.countArray = this.count
        .toString()
        .split('')
        .map(item => +item);
    }
    if (mwcOverflowCount) {
      this.generateMaxNumberArray();
    }
  }
}
